import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stergeTargetareListaFisier } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useStergeTargetareListaFisier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stergeTargetareListaFisier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.liste() });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
